/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import OutsideWallModel from './OutsideWallModel'
import InsideWallModel from './InsideWallModel'

const BackStorage = () => {

    return (
        <group position={[0, 0, 0.15]}>
            <OutsideWallModel />
            <InsideWallModel />
        </group>
    )
}

export default BackStorage